// eslint-disable-next-line prefer-const
let Prelogin = (function (prelogin) {
    let initialized = false;

    prelogin.init = function () {
        if (initialized) {
            return;
        }
        initialized = true;

        $('body').on('click', '.go-top', (e) => {
            e.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        });

        $('body').on('click', '#overlay', () => {
            if ($('.prelogin-navbar').hasClass('open')) {
                $('.prelogin-navbar').removeClass('open');
                $('#overlay').fadeOut();
                $('#main-body').removeClass('blur');
            }
            if ($('#expanding-menu').hasClass('open')) {
                $('#expanding-menu').removeClass('open');
                $('#overlay').fadeOut();
                $('#content-container').removeClass('blur');
                $('#main-body').removeClass('blur');
            }
        });

        $('.navbar').on('click', '#prelogin-menu-trigger', (e) => {
            e.stopPropagation();

            if (!$('#overlay').length) {
                $('body').append('<div id="overlay"></div>');
            }
            if ($('.prelogin-navbar').hasClass('open')) {
                $('.prelogin-navbar').removeClass('open');
                $('#overlay').fadeOut();
                $('#main-body').removeClass('blur');
            } else {
                $('.prelogin-navbar').addClass('open');
                $('#overlay').fadeIn();
                $('#main-body').addClass('blur');
            }
        });

        // Mobile hamburger menu toggle
        $('header.site-header').on('click', '.hamburger-toggle', function () {
            const $header = $(this).closest('header.site-header');
            const $icon = $(this).find('i');
            const isOpen = $header.hasClass('menu-open');

            $header.toggleClass('menu-open');
            $(this).attr('aria-expanded', !isOpen);
            $icon.toggleClass('fa-bars', isOpen).toggleClass('fa-xmark', !isOpen);
        });

        $('header.site-header .nav-menu-container').on('click', 'a', function () {
            const $header = $('header.site-header');
            const $hamburger = $header.find('.hamburger-toggle');
            $header.removeClass('menu-open');
            $hamburger.attr('aria-expanded', 'false');
            $hamburger.find('i').removeClass('fa-xmark').addClass('fa-bars');
        });

        $('.btn, .nav > li > a').addClass('ripple');
        setupGsap();
    };

    const setupGsap = () => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to('#cloud-1', {
            scrollTrigger: {
                start: 'top top',
                endTrigger: '#sub-footer',
                scrub: true,
            },
            backgroundPosition: '-200px -300px',
        });

        gsap.to('#cloud-2', {
            scrollTrigger: {
                start: 'top top',
                endTrigger: '#sub-footer',
                scrub: true,
            },
            backgroundPosition: '-400px -350px',
        });

        gsap.to('#cloud-3', {
            scrollTrigger: {
                start: 'top top',
                endTrigger: '#sub-footer',
                scrub: true,
            },
            backgroundPosition: '-900px -350px',
        });

        gsap.to('#cloud-4', {
            scrollTrigger: {
                start: 'top top',
                endTrigger: '#sub-footer',
                scrub: true,
            },
            backgroundPosition: '-1800px -340px',
        });

        // Footer with scrolling beep & volt
        const beep8Bit = $('#beep-8-bit');
        const volt8Bit = $('#volt-8-bit');

        gsap.to(beep8Bit, {
            transform: 'translate(100vw, 0px)',
            duration: 3,
            ease: 'power2.in',
            scrollTrigger: {
                trigger: '#beep-8-bit',
                start: 'top 90%',
                toggleActions: 'play complete reverse reset',
            },
        });

        gsap.to(volt8Bit, {
            transform: 'translate(100vw, 0px)',
            duration: 3,
            ease: 'power3.in',
            scrollTrigger: {
                trigger: '#volt-8-bit',
                start: 'top 90%',
                toggleActions: 'play complete reverse reset',
            },
        });

        // Go to top button
        const goToTop = $('.go-top');
        gsap.to(goToTop, {
            marginLeft: '0px',
            duration: 1,
            scrollTrigger: {
                trigger: '#section-2',
                start: 'bottom 10%',
                scrub: false,
                toggleActions: 'play complete reverse reset',
            },
        });
    };

    const topAlert = $('#top-alert-container');
    if ($(window).width() >= 768) {
        topAlert.html(
            `<div class="alert text-center" id="top-alert" role="alert">
                Planned Website Maintenance Scheduled
                Saturday, October 17 from 8:30pm ET - 11:00pm ET
                </div>`,
        );
    } else {
        topAlert.html('');
    }

    return prelogin;
}(Prelogin || {}));
